import { render } from "./FormKategori.vue?vue&type=template&id=2ea87ba8"
import script from "./FormKategori.vue?vue&type=script&lang=js"
export * from "./FormKategori.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__